import { X, UploadCloud, Loader2 } from "lucide-react";
import { useState } from "react";
import Swal from "sweetalert2";
import { uploadImage } from "../../../utils/uploadImage"; // Sesuaikan path
import { GOOGLE_SHEET_URL } from "../../../utils/googleSheet";
interface Props {
  open: boolean;
  onClose: () => void;
}

const AspirasiModal = ({ open, onClose }: Props) => {
  const [nama, setNama] = useState("");
  const [noHp, setNoHp] = useState("");
  const [alamat, setAlamat] = useState("-");
  const [aspirasi, setAspirasi] = useState("");

  const [image, setImage] = useState<File | null>(null);
  const [preview, setPreview] = useState<string>("");

  const [loading, setLoading] = useState(false);
  const isFormValid = nama.trim() !== "" && noHp.trim() !== "" && aspirasi.trim() !== "";

  if (!open) return null;

  const handleImage = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) return;

    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      let fotoUrl = "";

      if (image) {
        const uploadResult = await uploadImage(image);
        fotoUrl = uploadResult.secure_url;
      }

      const formData = new FormData();
      formData.append("nama", nama);
      formData.append("no_hp", noHp);
      formData.append("alamat", alamat);
      formData.append("aspirasi", aspirasi);
      formData.append("foto", fotoUrl);

      await fetch(GOOGLE_SHEET_URL, {
        method: "POST",
        body: formData,
      });

      // reset form
      setNama("");
      setNoHp("");
      setAlamat("");
      setAspirasi("");
      setImage(null);
      setPreview("");

      // matiin loading & tutup modal DULUAN
      setLoading(false);
      onClose();

      // baru tampilin notifikasi sukses, tanpa await (non-blocking)
      Swal.fire({
        icon: "success",
        title: "Berhasil 🎉",
        text: "Terima kasih. Aspirasi Anda berhasil dikirim.",
        confirmButtonColor: "#16a34a",
      });
    } catch (err) {
      console.error(err);

      setLoading(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Terjadi kesalahan saat mengirim aspirasi.",
        confirmButtonColor: "#dc2626",
      });
    }
  };

  return (
    <div className="fixed inset-0 z-[999999999] flex items-center justify-center bg-black/70 backdrop-blur-sm p-5">
      <div className="w-full max-w-2xl overflow-hidden rounded-3xl bg-white shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between bg-gradient-to-r from-lime-600 to-green-600 p-6 text-white">
          <div>
            <h2 className="text-2xl font-bold">Sampaikan Aspirasi</h2>

            <p className="mt-1 text-green-100">Masukan Anda sangat berarti bagi kemajuan bersama.</p>
          </div>

          <button onClick={onClose}>
            <X size={28} />
          </button>
        </div>

        {/* Body */}

        <div className="max-h-96 space-y-5 overflow-y-auto p-7">
          <div className="grid gap-5 md:grid-cols-2">
            <div>
              <label className="font-medium">Nama Lengkap</label>

              <input value={nama} onChange={(e) => setNama(e.target.value)} className="mt-2 w-full rounded-xl border p-3 outline-none focus:ring-2 focus:ring-lime-500" placeholder="Masukkan nama lengkap" />
            </div>

            <div>
              <label className="font-medium">Nomor Telepon</label>

              <input value={noHp} onChange={(e) => setNoHp(e.target.value)} className="mt-2 w-full rounded-xl border p-3 outline-none focus:ring-2 focus:ring-lime-500" placeholder="08xxxxxxxxxx" />
            </div>
          </div>

          {/* <div>
            <label className="font-medium">Alamat</label>

            <textarea rows={2} value={alamat} onChange={(e) => setAlamat(e.target.value)} className="mt-2 w-full rounded-xl border p-3 outline-none focus:ring-2 focus:ring-lime-500" placeholder="Alamat lengkap..." />
          </div> */}

          <div>
            <label className="font-medium">Aspirasi</label>

            <textarea
              rows={5}
              value={aspirasi}
              onChange={(e) => setAspirasi(e.target.value)}
              className="mt-2 w-full rounded-xl border p-3 outline-none focus:ring-2 focus:ring-lime-500"
              placeholder="Tuliskan kritik, saran, maupun usulan..."
            />
          </div>

          <div>
            <label className="mb-2 block font-medium">Foto Pendukung (Opsional)</label>

            <label className="flex h-44 cursor-pointer flex-col items-center justify-center rounded-2xl border-2 border-dashed hover:bg-gray-50">
              <UploadCloud size={40} className="text-lime-600" />

              <span className="mt-2 text-gray-500">Klik untuk memilih foto</span>

              <input hidden type="file" accept="image/*" onChange={handleImage} />
            </label>

            {preview && <img src={preview} alt="" className="mt-4 h-60 w-full rounded-xl object-cover" />}
          </div>
        </div>

        {/* Footer */}

        <div className="flex justify-end gap-3 bg-gray-50 p-5">
          <button onClick={onClose} disabled={loading} className="rounded-xl border px-6 py-3">
            Batal
          </button>

          <button
            onClick={handleSubmit}
            disabled={!isFormValid || loading}
            className="
    flex items-center gap-2 rounded-xl
    bg-lime-600 px-7 py-3
    font-semibold text-white
    transition
    hover:bg-lime-700
    disabled:bg-gray-300
    disabled:text-gray-500
    disabled:cursor-not-allowed
  ">
            {loading && <Loader2 size={18} className="animate-spin" />}

            {loading ? "Mengirim..." : "Kirim Aspirasi"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AspirasiModal;
